<!-- src/pages/MyPage.vue -->
<script setup>
import { computed } from 'vue';
import MobileHeader from '@/components/common/MobileHeader.vue';

definePage({ meta: { layout: 'mypage' } });
const router = useRouter();
const route = useRoute();

const isWebView = ref(false);
onMounted(() => {
  isWebView.value = !!window.ReactNativeWebView;
});

/** 이전 페이지 검사 */
function hasBackNow() {
  const st = window.history.state || null;
  if (st && typeof st.position === 'number') return st.position > 0;
  if (st && st.back != null) return true;
  return false;
}

/** 뒤로가기 핸들러 */
const handleBack = () => {
  if (hasBackNow()) {
    router.back();
  } else {
    router.push('/main');
  }
};

const finishTitle = computed(() =>
  route.query.type === 'eventinquiry' ? '신청 접수 완료' : '문의 접수 완료',
);
const finishDesc = computed(() =>
  route.query.type === 'eventinquiry'
    ? '신청하신 내용이 정상적으로 접수 되었습니다.\n답변은 마이페이지>문의/신청>내역보기에서 확인 가능합니다.'
    : '문의하신 내용이 정상적으로 접수 되었습니다.\n답변은 마이페이지>문의/신청>내역보기에서 확인 가능합니다.',
);

const writeButtonText = computed(() =>
  route.query.type === 'eventinquiry' ? '새로운 신청 작성하기' : '새로운 문의 작성하기',
);

const handleSubmit = () => {
  router.push({
    path: '/mypage/inquiry',
    query: { type: route.query.type || 'inquiry' },
  });
};

const goList = () => {
  router.push({
    path: '/mypage/inquiryList',
    query: { boardName: route.query.type || 'inquiry' },
  });
};
</script>

<template>
  <div class="my-info-wrap inquiry-finish-page">
    <MobileHeader
      title="문의/신청"
      :show-back="isWebView"
      :show-menu="!isWebView"
      @back="handleBack"
    />
    <div class="my-tit-box com-bg-my-box h-small">
      <div class="tit tit-box">
        <span>문의/신청</span>
        <div class="tit-exp">문의하신 내용은 내역보기에서 확인하실 수 있습니다.</div>
      </div>
    </div>
    <div class="myinfo-box com-bg-my-box">
      <div class="finish-box">
        <div class="com-btn-box">
          <i class="icon-check"> </i>
        </div>
        <div class="gap-xxl"></div>
        <div class="fnt-big">{{ finishTitle }}</div>
        <div class="fnt-fail-msg" v-html="finishDesc.replace(/\n/g, '<br />')"></div>
        <div class="payment-line-msg-box">
          <button class="fnt-line-red" @click="handleSubmit">{{ writeButtonText }}</button>
        </div>
        <div class="com-btn-box">
          <VBtn
            type="submit"
            class="inquiry-finish-page__list-btn"
            style="width: 260px"
            @click="goList"
          >
            내역보기 확인하기
          </VBtn>
        </div>
        <!-- <div class="gap-xxl"></div>  -->
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.inquiry-finish-page {
  .fnt-big {
    text-align: center;
  }

  .tit-box {
    display: flex;
    align-items: center;
    gap: 40px;

    .tit-exp {
      color: var(--Gray-700, #575757);
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px; /* 138.462% */
    }
  }

  .fnt-fail-msg {
    margin-top: 16px;
    color: var(--Gray-700, #575757);
    text-align: center;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.375px;
  }

  .payment-line-msg-box {
    padding: 32px 0 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fnt-line-red {
    color: var(--orange-300-main, #eb4c10);
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
    letter-spacing: -0.35px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
}

@media (max-width: 768px) {
  .inquiry-finish-page {
    height: 100dvh;
    width: 100vw;
    margin-bottom: 0;
    padding-top: 52px;

    .my-tit-box {
      display: none;
    }

    .myinfo-box.com-bg-my-box {
      margin-bottom: 0;
      border-radius: 0;
      padding: 0;
      height: 100%;
    }

    .finish-box {
      height: 100%;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      padding: 0 16px calc(var(--safe-area-bottom, 0px) + 52px);
    }

    .fnt-fail-msg {
      margin-top: 12px;
      font-size: 14px;
      line-height: 20px;
    }

    .payment-line-msg-box {
      padding: 24px 0 32px;
    }

    .inquiry-finish-page__list-btn {
      width: 100% !important;
    }

    .finish-box .com-btn-box {
      width: 100%;
    }

    .finish-box .com-btn-box .v-btn {
      width: 100% !important;
    }
  }
}
</style>
